/**
 * Utility per la decodifica del Codice Fiscale Italiano
 */

// Mappa mesi CF
const monthMap = {
  'A': '01', 'B': '02', 'C': '03', 'D': '04', 'E': '05', 'H': '06',
  'L': '07', 'M': '08', 'P': '09', 'R': '10', 'S': '11', 'T': '12'
};

// Database comuni italiani (codici catastali più comuni)
const comuniCatastali = {
  'A944': { nome: 'Bari', provincia: 'BA' },
  'B354': { nome: 'Bergamo', provincia: 'BG' },
  'A794': { nome: 'Bologna', provincia: 'BO' },
  'B157': { nome: 'Brescia', provincia: 'BS' },
  'B963': { nome: 'Cagliari', provincia: 'CA' },
  'C351': { nome: 'Catania', provincia: 'CT' },
  'C847': { nome: 'Cesena', provincia: 'FC' },
  'C933': { nome: 'Chieti', provincia: 'CH' },
  'D612': { nome: 'Ferrara', provincia: 'FE' },
  'D643': { nome: 'Firenze', provincia: 'FI' },
  'E038': { nome: 'Forlì', provincia: 'FC' },
  'E205': { nome: 'Genova', provincia: 'GE' },
  'E625': { nome: "L'Aquila", provincia: 'AQ' },
  'E715': { nome: 'Latina', provincia: 'LT' },
  'F205': { nome: 'Milano', provincia: 'MI' },
  'F257': { nome: 'Modena', provincia: 'MO' },
  'F839': { nome: 'Napoli', provincia: 'NA' },
  'G224': { nome: 'Padova', provincia: 'PD' },
  'G273': { nome: 'Palermo', provincia: 'PA' },
  'G337': { nome: 'Parma', provincia: 'PR' },
  'G388': { nome: 'Pavia', provincia: 'PV' },
  'G478': { nome: 'Perugia', provincia: 'PG' },
  'G628': { nome: 'Piacenza', provincia: 'PC' },
  'G702': { nome: 'Pisa', provincia: 'PI' },
  'G942': { nome: 'Pordenone', provincia: 'PN' },
  'H163': { nome: 'Ravenna', provincia: 'RA' },
  'H224': { nome: 'Reggio Calabria', provincia: 'RC' },
  'H223': { nome: 'Reggio Emilia', provincia: 'RE' },
  'H294': { nome: 'Rieti', provincia: 'RI' },
  'H501': { nome: 'Roma', provincia: 'RM' },
  'I138': { nome: 'Salerno', provincia: 'SA' },
  'I726': { nome: 'Siena', provincia: 'SI' },
  'L049': { nome: 'Taranto', provincia: 'TA' },
  'L219': { nome: 'Torino', provincia: 'TO' },
  'L378': { nome: 'Treviso', provincia: 'TV' },
  'L424': { nome: 'Trieste', provincia: 'TS' },
  'L483': { nome: 'Udine', provincia: 'UD' },
  'L682': { nome: 'Varese', provincia: 'VA' },
  'L736': { nome: 'Venezia', provincia: 'VE' },
  'L781': { nome: 'Verona', provincia: 'VR' },
  'L840': { nome: 'Vicenza', provincia: 'VI' },
  'M082': { nome: 'Viterbo', provincia: 'VT' },
  'A271': { nome: 'Ancona', provincia: 'AN' },
  'A052': { nome: 'Aosta', provincia: 'AO' },
  'A662': { nome: 'Asti', provincia: 'AT' },
  'A669': { nome: 'Avellino', provincia: 'AV' },
  'B180': { nome: 'Benevento', provincia: 'BN' },
  'B848': { nome: 'Campobasso', provincia: 'CB' },
  'C034': { nome: 'Caserta', provincia: 'CE' },
  'C352': { nome: 'Catanzaro', provincia: 'CZ' },
  'C772': { nome: 'Como', provincia: 'CO' },
  'C773': { nome: 'Cosenza', provincia: 'CS' },
  'D086': { nome: 'Cremona', provincia: 'CR' },
  'D122': { nome: 'Crotone', provincia: 'KR' },
  'D150': { nome: 'Cuneo', provincia: 'CN' },
  'E041': { nome: 'Foggia', provincia: 'FG' },
  'E098': { nome: 'Frosinone', provincia: 'FR' },
  'E281': { nome: 'Gorizia', provincia: 'GO' },
  'E289': { nome: 'Grosseto', provincia: 'GR' },
  'E507': { nome: 'Imperia', provincia: 'IM' },
  'E512': { nome: 'Isernia', provincia: 'IS' },
  'E648': { nome: 'La Spezia', provincia: 'SP' },
  'E745': { nome: 'Lecce', provincia: 'LE' },
  'E746': { nome: 'Lecco', provincia: 'LC' },
  'E819': { nome: 'Livorno', provincia: 'LI' },
  'E837': { nome: 'Lodi', provincia: 'LO' },
  'E891': { nome: 'Lucca', provincia: 'LU' },
  'E897': { nome: 'Macerata', provincia: 'MC' },
  'E954': { nome: 'Mantova', provincia: 'MN' },
  'E972': { nome: 'Massa', provincia: 'MS' },
  'F007': { nome: 'Matera', provincia: 'MT' },
  'F058': { nome: 'Messina', provincia: 'ME' },
  'F383': { nome: 'Monza', provincia: 'MB' },
  'F463': { nome: 'Novara', provincia: 'NO' },
  'F480': { nome: 'Nuoro', provincia: 'NU' },
  'F557': { nome: 'Olbia', provincia: 'SS' },
  'F565': { nome: 'Oristano', provincia: 'OR' },
  'G482': { nome: 'Pesaro', provincia: 'PU' },
  'G535': { nome: 'Pescara', provincia: 'PE' },
  'G713': { nome: 'Pistoia', provincia: 'PT' },
  'G804': { nome: 'Potenza', provincia: 'PZ' },
  'G786': { nome: 'Prato', provincia: 'PO' },
  'H151': { nome: 'Ragusa', provincia: 'RG' },
  'H484': { nome: 'Rimini', provincia: 'RN' },
  'H620': { nome: 'Rovigo', provincia: 'RO' },
  'H703': { nome: 'Salerno', provincia: 'SA' },
  'I452': { nome: 'Sassari', provincia: 'SS' },
  'I480': { nome: 'Savona', provincia: 'SV' },
  'I874': { nome: 'Sondrio', provincia: 'SO' },
  'I930': { nome: 'Siracusa', provincia: 'SR' },
  'L120': { nome: 'Teramo', provincia: 'TE' },
  'L117': { nome: 'Terni', provincia: 'TR' },
  'L407': { nome: 'Trapani', provincia: 'TP' },
  'L565': { nome: 'Urbino', provincia: 'PU' },
  'L850': { nome: 'Vibo Valentia', provincia: 'VV' },
  // Aggiungo altri comuni frequenti
  'A007': { nome: 'Abbadia San Salvatore', provincia: 'SI' },
  'Z100': { nome: 'Albania', provincia: 'EE' },
  'Z101': { nome: 'Andorra', provincia: 'EE' },
  'Z102': { nome: 'Austria', provincia: 'EE' },
  'Z103': { nome: 'Belgio', provincia: 'EE' },
  'Z104': { nome: 'Bulgaria', provincia: 'EE' },
  'Z105': { nome: 'Cecoslovacchia', provincia: 'EE' },
  'Z106': { nome: 'Città del Vaticano', provincia: 'EE' },
  'Z107': { nome: 'Danimarca', provincia: 'EE' },
  'Z108': { nome: 'Estonia', provincia: 'EE' },
  'Z109': { nome: 'Finlandia', provincia: 'EE' },
  'Z110': { nome: 'Francia', provincia: 'EE' },
  'Z111': { nome: 'Germania', provincia: 'EE' },
  'Z112': { nome: 'Regno Unito', provincia: 'EE' },
  'Z113': { nome: 'Grecia', provincia: 'EE' },
  'Z114': { nome: 'Irlanda', provincia: 'EE' },
  'Z115': { nome: 'Islanda', provincia: 'EE' },
  'Z116': { nome: 'Iugoslavia', provincia: 'EE' },
  'Z117': { nome: 'Lettonia', provincia: 'EE' },
  'Z118': { nome: 'Liechtenstein', provincia: 'EE' },
  'Z119': { nome: 'Lituania', provincia: 'EE' },
  'Z120': { nome: 'Lussemburgo', provincia: 'EE' },
  'Z121': { nome: 'Malta', provincia: 'EE' },
  'Z122': { nome: 'Monaco', provincia: 'EE' },
  'Z123': { nome: 'Norvegia', provincia: 'EE' },
  'Z124': { nome: 'Paesi Bassi', provincia: 'EE' },
  'Z125': { nome: 'Polonia', provincia: 'EE' },
  'Z126': { nome: 'Portogallo', provincia: 'EE' },
  'Z127': { nome: 'Romania', provincia: 'EE' },
  'Z128': { nome: 'San Marino', provincia: 'EE' },
  'Z129': { nome: 'Spagna', provincia: 'EE' },
  'Z130': { nome: 'Svezia', provincia: 'EE' },
  'Z131': { nome: 'Svizzera', provincia: 'EE' },
  'Z132': { nome: 'Ungheria', provincia: 'EE' },
  'Z133': { nome: 'Ucraina', provincia: 'EE' },
  'Z134': { nome: 'Russia', provincia: 'EE' },
};

/**
 * Decodifica un Codice Fiscale italiano
 * @param {string} cf - Codice Fiscale da decodificare
 * @returns {object} Dati estratti dal CF
 */
export const decodeFiscalCode = (cf) => {
  if (!cf || cf.length !== 16) {
    return null;
  }

  const cfUpper = cf.toUpperCase();
  
  // Estrai le parti del CF
  const cognomeCode = cfUpper.substring(0, 3);  // Prime 3 lettere = cognome
  const nomeCode = cfUpper.substring(3, 6);     // Lettere 4-6 = nome
  const annoCode = cfUpper.substring(6, 8);     // Caratteri 7-8 = anno
  const meseCode = cfUpper.substring(8, 9);     // Carattere 9 = mese
  const giornoCode = cfUpper.substring(9, 11);  // Caratteri 10-11 = giorno
  const comuneCode = cfUpper.substring(11, 15); // Caratteri 12-15 = comune
  const controlCode = cfUpper.substring(15, 16); // Carattere 16 = controllo

  // Calcola anno di nascita (gestisce sia 1900 che 2000)
  const annoNum = parseInt(annoCode);
  const currentYear = new Date().getFullYear() % 100;
  const fullYear = annoNum > currentYear ? 1900 + annoNum : 2000 + annoNum;

  // Calcola mese
  const mese = monthMap[meseCode] || '01';

  // Calcola giorno e sesso
  const giornoNum = parseInt(giornoCode);
  const isFemale = giornoNum > 40;
  const giorno = isFemale ? giornoNum - 40 : giornoNum;
  const sesso = isFemale ? 'F' : 'M';

  // Formatta data di nascita
  const dataNascita = `${fullYear}-${mese}-${String(giorno).padStart(2, '0')}`;

  // Cerca il comune
  const comune = comuniCatastali[comuneCode] || { 
    nome: `Comune ${comuneCode}`, 
    provincia: 'XX' 
  };

  return {
    codiceFiscale: cfUpper,
    cognomeCode,
    nomeCode,
    annoNascita: fullYear,
    meseNascita: parseInt(mese),
    giornoNascita: giorno,
    dataNascita,
    sesso,
    sessoEsteso: sesso === 'M' ? 'Maschio' : 'Femmina',
    luogoNascita: comune.nome,
    provinciaNascita: comune.provincia,
    codiceCatastale: comuneCode,
    carattereControllo: controlCode
  };
};

/**
 * Calcola l'età da una data di nascita
 * @param {string} dataNascita - Data in formato YYYY-MM-DD
 * @returns {number} Età in anni
 */
export const calculateAge = (dataNascita) => {
  const birthDate = new Date(dataNascita);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  
  return age;
};

/**
 * Valida il formato di un Codice Fiscale
 * @param {string} cf - Codice Fiscale da validare
 * @returns {boolean} true se il formato è valido
 */
export const validateFiscalCode = (cf) => {
  if (!cf || cf.length !== 16) return false;
  
  // Pattern: 6 lettere + 2 numeri + 1 lettera + 2 numeri + 1 lettera + 3 caratteri alfanumerici + 1 lettera
  const pattern = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/i;
  return pattern.test(cf);
};

/**
 * Formatta una data in italiano
 * @param {string} date - Data in formato YYYY-MM-DD
 * @returns {string} Data formattata (es: "1 gennaio 1974")
 */
export const formatDateItalian = (date) => {
  const options = { day: 'numeric', month: 'long', year: 'numeric' };
  return new Date(date).toLocaleDateString('it-IT', options);
};

export default {
  decodeFiscalCode,
  calculateAge,
  validateFiscalCode,
  formatDateItalian
};
